import * as React from 'react';
import { IconProps } from '../types';

const IcQuickCommission = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      fill={props?.fill ?? '#232F3E'}
      stroke="#232F3E"
      strokeWidth={0.5}
      d="M23.007 14.85a1.345 1.345 0 0 0-1.127-.318l-8.39 1.52-2.384-2.482a.413.413 0 0 0-.299-.13h-4.23c0-.243-.19-.44-.424-.44H1.5v.881h2.538v6.17H1.5v.881h4.653a.432.432 0 0 0 .423-.44h1.17l4.523 2.355a1.335 1.335 0 0 0 1.315-.044l9.23-5.608c.423-.257.686-.734.686-1.244 0-.426-.18-.828-.493-1.102ZM5.73 20.05h-.846v-6.169h.846v6.17Zm16.657-3.616-9.23 5.608a.517.517 0 0 1-.51.017l-4.612-2.402a.408.408 0 0 0-.19-.047H6.577v-5.288h4.056l3.334 3.472a.819.819 0 0 1 .226.57c0 .444-.347.806-.774.806a.764.764 0 0 1-.547-.237l-2.188-2.278-.598.623 2.188 2.279c.306.319.712.494 1.145.494.893 0 1.62-.757 1.62-1.687 0-.45-.168-.874-.474-1.193l-.343-.357 7.804-1.414a.52.52 0 0 1 .437.123.568.568 0 0 1 .191.428.566.566 0 0 1-.266.483Z"
    />
    <path
      fill={props?.fill ?? '#232F3E'}
      d="m17.554 1-8.929 9.82 1.322 1.203 8.929-9.821L17.554 1ZM10.178 6.51a2.682 2.682 0 0 0 2.679-2.68 2.682 2.682 0 0 0-2.679-2.678A2.682 2.682 0 0 0 7.5 3.831a2.682 2.682 0 0 0 2.678 2.678Zm0-3.572a.894.894 0 0 1 0 1.786.894.894 0 0 1 0-1.786ZM14.642 9.188a2.682 2.682 0 0 0 2.679 2.678 2.682 2.682 0 0 0 2.678-2.678 2.682 2.682 0 0 0-2.678-2.679 2.682 2.682 0 0 0-2.679 2.679Zm3.572 0a.894.894 0 1 1-1.788-.002.894.894 0 0 1 1.788.002Z"
    />
  </svg>
);

export default IcQuickCommission;
